import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { CardRequestsFilterService } from '../home-cards/card-requests/card-requests-filter.service';
import { FreelancerRequestsFilterService } from '../home-freelancers/freelancer-requests/freelancer-requests-filter.service';
import { InnovationRequestsFilterService } from '../home-innovation/innovation-requests/innovation-requests-filter.service';
import { StandardRequestsFilterService } from '../home-standard/standard-requests/standard-requests-filter.service';

@Injectable({
    providedIn: 'root'
})

export class LoginService {

    showLoginDialog = false;
    accessControlList: string[] = [];

    constructor(
        private readonly apiService: ApiService,
        private readonly authenticationService: AuthenticationService,
        private readonly configurationService: ConfigurationService,
        private readonly freelancerRequestFilterService: FreelancerRequestsFilterService,
        private readonly cardRequestFilterService: CardRequestsFilterService,
        private readonly standardRequestFilterService: StandardRequestsFilterService,
        private readonly innovationRequestFilterService: InnovationRequestsFilterService,
        private readonly router: Router,
        private readonly utilsService: UtilsService
    ) { }

    async logout() {
        void this.apiService.get('users/signout');

        sessionStorage.removeItem('currentUser');
        localStorage.removeItem("jsonViewerObject");

        this.configurationService.setDefaultStyle();
        this.authenticationService.setPswd(null);
        this.authenticationService.currentUserSubject.next(null);
        this.accessControlList = [];

        const roles = (await this.utilsService.getCookieUser()).roles;
        /*if (roles.includes('WEB_OPENDATA_AUTONOMOS') || roles.includes('WEB_OPENDATA_AUTONOMOS_GESTOR')) {
            this.freelancerRequestFilterService.clearAllFiltersAndGlobalSearch();
            this.freelancerRequestFilterService.resetSortField();
        }*/
        if (roles.includes('WEB_OPENDATA_TARJETAS') || roles.includes('WEB_OPENDATA_TARJETAS_GESTOR')) {
            this.cardRequestFilterService.clearAllFiltersAndGlobalSearch();
            this.cardRequestFilterService.resetSortField();
        } else if (roles.includes('WEB_OPENDATA_ESTANDAR') || roles.includes('WEB_OPENDATA_ESTANDAR_GESTOR')) {
            this.standardRequestFilterService.clearAllFiltersAndGlobalSearch();
            this.standardRequestFilterService.resetSortField();
        } else if (roles.includes('WEB_OPENDATA_INNOVACION') || roles.includes('WEB_OPENDATA_INNOVACION_GESTOR') ||
                    roles.includes('WEB_OPENDATA_AUTONOMOS') || roles.includes('WEB_OPENDATA_AUTONOMOS_GESTOR')) {
            this.innovationRequestFilterService.clearAllFiltersAndGlobalSearch();
            this.innovationRequestFilterService.resetSortField();
        }

        // void this.oktaAuth.closeSession();
        this.utilsService.cleanCookieUser();
        this.router.navigate(['login']).catch(error => {console.error(error);});
    }
}
